import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box sx={{
      background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)',
      color: '#fff',
      py: 6,
      px: 2,
      mt: 8,
      borderTop: '3px solid #5FC0C1'
    }}>
      <Container maxWidth="lg">
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 4,
          mb: 4
        }}>
          {/* Riverview Info */}
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#5FC0C1' }}>
              Riverview
            </Typography>
            <Typography variant="body2" sx={{ color: '#d1d5db', lineHeight: 1.8 }}>
              Premium student accommodation designed for success.
            </Typography>
          </Box>

          {/* Quick Links */}
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#5FC0C1' }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/" sx={{ color: '#d1d5db', textDecoration: 'none', '&:hover': { color: '#5FC0C1' } }}>
                Home
              </Link>
              <Link href="/apply" sx={{ color: '#d1d5db', textDecoration: 'none', '&:hover': { color: '#5FC0C1' } }}>
                Apply Now
              </Link>
              <Link href="/" sx={{ color: '#d1d5db', textDecoration: 'none', '&:hover': { color: '#5FC0C1' } }}>
                Contact Us
              </Link>
            </Box>
          </Box>
        </Box>

        {/* Bottom Section */}
        <Box sx={{
          borderTop: '1px solid rgba(209, 213, 219, 0.2)',
          pt: 4,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2
        }}>
          <Typography variant="body2" sx={{ color: '#9ca3af' }}>
            © {currentYear} Riverview. All rights reserved.
          </Typography>
          
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            justifyContent: { xs: 'center', md: 'flex-end' }
          }}>
            <Typography variant="caption" sx={{ color: '#9ca3af' }}>
              Powered by
            </Typography>
            <img src={process.env.PUBLIC_URL + '/hnf-logo.png'} alt="HNF Holdings" style={{ width: 32, height: 32, objectFit: 'contain' }} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
